import { ParametrosSalvarOuAtualizarPrevisaoVendas, RetornoGetPrevisaoVendasItem } from '@core/services/vendas.interface'

export class JuntarPrevisaoSalvaComNovaPrevisaoService{
  private getIdLinhasString(linhaId: number){
    return linhaId === 2 ? "2" : "1, 3, 7, 8";
  }

  execute(cliente: RetornoGetPrevisaoVendasItem, novasPrevisoes: ParametrosSalvarOuAtualizarPrevisaoVendas[], novasPrevisoesSalvas: ParametrosSalvarOuAtualizarPrevisaoVendas[]){
    const previsaoVendaPorCliente = cliente.previsaoVenda.map(previsao => ({
      ...previsao
    }))

    const newPrevisaoVendaPorCliente = novasPrevisoes.filter(previsao => previsao.idCliente === cliente.idCliente)

    newPrevisaoVendaPorCliente.forEach((previsao)=>{
      const oldPrevisaoIndex = previsaoVendaPorCliente.findIndex(
        oldPrevisao => (
          cliente.idCliente === previsao.idCliente &&
          oldPrevisao.anoMes === previsao.noAnoMes &&
          oldPrevisao.linhas === this.getIdLinhasString(previsao.idLinhaProduto)
        )
      )

      const newPrevisao = {
        anoMes: previsao.noAnoMes,
        linhas: this.getIdLinhasString(previsao.idLinhaProduto),
        quantidade: previsao.quantidade
      }

      if(oldPrevisaoIndex !== -1){
        previsaoVendaPorCliente[oldPrevisaoIndex] = newPrevisao
      }else{
        previsaoVendaPorCliente.push(newPrevisao )
      }
    })

    const newPrevisaoVendaSalvaPorCliente = novasPrevisoesSalvas.filter(previsao => previsao.idCliente === cliente.idCliente)

    newPrevisaoVendaSalvaPorCliente.forEach((previsao)=>{
      const oldPrevisaoIndex = newPrevisaoVendaPorCliente.findIndex(
        oldPrevisao => (
          cliente.idCliente === previsao.idCliente &&
          oldPrevisao.noAnoMes === previsao.noAnoMes &&
          this.getIdLinhasString(oldPrevisao.idLinhaProduto) === this.getIdLinhasString(previsao.idLinhaProduto)
        )
      )

      const newPrevisao = {
        anoMes: previsao.noAnoMes,
        linhas: this.getIdLinhasString(previsao.idLinhaProduto),
        quantidade: previsao.quantidade
      }

      if(oldPrevisaoIndex !== -1){
        previsaoVendaPorCliente[oldPrevisaoIndex] = newPrevisao
      }else{
        previsaoVendaPorCliente.push(newPrevisao )
      }
    })

    return previsaoVendaPorCliente;
  }
}
